import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BraquetService {
  private key = 'braquetResult';
  BraquetMatrixResult: any[] = [];
  Travel_code: string;
  config: any = {
    date_deb: null,
    date_fin: null,
    nbrPersonneList: [],
  };
  constructor() {
    this.loadListFromLocalStorage();
  }

  loadListFromLocalStorage(): void {
    const objectString = localStorage.getItem(this.key);
    if (objectString) {
      const object = JSON.parse(objectString);
      this.BraquetMatrixResult = object.data;
      this.Travel_code = object.Travel_code;
      this.config = object.config;
    }
  }

  checkExistingResult(): boolean {
    return localStorage.getItem(this.key) ? true : false;
  }

  getSharedBraquetMatrixResult(): any[] {
    return this.BraquetMatrixResult;
  }

  getTravel_codeFromBraquetMatrixResult(): string {
    return this.Travel_code;
  }

  getBraquetInitialConfig(): string {
    return this.config;
  }
  saveListToLocalStorage(): void {
    localStorage.setItem(
      this.key,
      JSON.stringify({
        Travel_code: this.Travel_code,
        config: this.config,
        data: this.BraquetMatrixResult,
      })
    );
  }

  removeListFromLocalStorage(): void {
    localStorage.removeItem(this.key);
  }

  //! ********** validator functions ****************

  validatCalculCircuit(dsReservation, resCalcul, listeEvennement) {
    var exist = false;
    var listTravelDVerified = [];
    var listTravelDToVerifyError = [];
    dsReservation.TravelD.forEach((element) => {
      var findIt = false;
      for (let i = 0; i <= resCalcul.length - 2; i++) {
        if (resCalcul[i]) {
          if (
            element.TravelD_Pos == resCalcul[i].TravelD_Pos &&
            element.TravelD_Jour == resCalcul[i].TravelD_Jour
          ) {
            listTravelDVerified.push(element);
            findIt = true;
            break;
          } else if (
            listeEvennement?.find(
              (e) =>
                e.evennemtCode == element.TravelD_EventCode && e.payant == 0
            )
          ) {
            listTravelDVerified.push(element);
            findIt = true;
            break;
          }
        }
      }
      if (!findIt) {
        exist = true;
      }
    });
    listTravelDToVerifyError = this.deleteListfromlist(
      dsReservation.TravelD,
      listTravelDVerified
    );

    return listTravelDToVerifyError.length != 0;
  }
  deleteListfromlist(List, listsupp) {
    listsupp.forEach((e1) => {
      if (List.find((e2) => e2 == e1)) {
        this.remove(List, e1);
      }
    });
    return List;
  }
  remove(list, value) {
    list.splice(list.indexOf(value), 1);
  }
}
